import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import {BrowserRouter} from "react-router-dom";
import PaiPoint from "pages/PaiPoint";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <>
      <BrowserRouter>
          <PaiPoint />
      </BrowserRouter>
  </>
);

